import { ApiError } from '../errors/api-error.js';

export class LifecycleApi {
    constructor(client) {
        this.client = client;
        this.basePath = '/lifecycle';
    }

    async getOne(entityType, entityId) {
        try {
            const et = encodeURIComponent(String(entityType));
            const eid = encodeURIComponent(String(entityId));
            const response = await this.client.get(`${this.basePath}/${et}/${eid}`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async bulk(items) {
        try {
            const response = await this.client.post(`${this.basePath}/bulk`, { items });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
